export class LineWorkProfileHandler {
    _lineProfileView;
    _currentLine;
    _site;
    constructor(args, lineProfileView) {
        this._site = args.site;
        this._lineProfileView = lineProfileView;
    }
    get currentLineId() {
        return this._currentLine.id;
    }
    renderProfileData(line) {
        this._currentLine = line;
        this._loadProfileData();
    }
    _loadProfileData() {
        const _2dViewData = this._currentLine.get2dViewerData(this._site);
        this._lineProfileView.renderData(this._currentLine.id, _2dViewData, true);
    }
    dispose(id) {
        if (this._currentLine?.id === id) {
            this._currentLine = undefined;
            this._lineProfileView.clearView();
        }
    }
}
//# sourceMappingURL=linework-profile-handler.js.map